export default __webpack_public_path__ + "static/media/0300.57f37eee.jpg";